
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"25.4","viewBox":"0 0 22 25.4"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"a","gradientUnits":"userSpaceOnUse","x1":"-110.649","y1":"136.478","x2":"-109.623","y2":"137.411","gradientTransform":"matrix(22.0018 0 0 -25.357 2436.21 3486.698)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#eb5c2b"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#da1c5c"}})]),_c('path',{attrs:{"fill":"url(#a)","d":"M21.2 4.4L13.5.2c-.8-.4-1.7-.1-2.1.6L6.8 9.2H1.3c-.7 0-1.3.6-1.3 1.3v13.6c0 .7.5 1.2 1.2 1.3h17.6c.7 0 1.2-.5 1.3-1.2V21h.5c.3 0 .5-.2.5-.5v-3.6c0-.3-.2-.5-.5-.5h-.5v-3.6c0-.6-.4-1.1-1-1.2l2.7-5c.4-.9.1-1.8-.6-2.2zm-5.5-1.9l-4.8 9H9.5L14.6 2l1.1.5zm-3.5-1.2c.1-.3.5-.4.8-.3l.8.4-5.4 10H6.7l5.5-10.1zM.9 10.5c0-.1.1-.2.3-.2h5l-.7 1.2H.9v-1zm18.2 13.6c0 .2-.1.3-.3.3H1.2c-.2 0-.3-.1-.3-.3V12.7c0-.2.1-.3.3-.3h17.6c.2 0 .3.1.3.3v3.6h-1.9c-.8 0-1.5.7-1.5 1.5v1.7c0 .8.7 1.5 1.5 1.5h1.9v3.1zm1-6.8V20h-2.9c-.3 0-.5-.2-.5-.5v-1.7c0-.3.2-.5.5-.5h2.9zM20.9 6L18 11.5h-6.1L16.5 3l4.2 2.3c.3.1.4.4.2.7.1 0 0 0 0 0z"}}),_c('linearGradient',{attrs:{"id":"b","gradientUnits":"userSpaceOnUse","x1":"-85.935","y1":"102.978","x2":"-78.805","y2":"110.133","gradientTransform":"matrix(3.3097 0 0 -3.4528 284.259 381.551)"}},[_c('stop',{attrs:{"offset":".306","stop-color":"#eb5c2b"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#da1c5c"}})]),_c('path',{attrs:{"fill":"url(#b)","d":"M18.9 5.5l-.3-.1c-.6-.3-1.4-.1-1.8.6l-.3.6c-.2.3-.2.7-.1 1.1.1.3.3.6.7.8l.3.1c.2.1.4.2.6.2.5 0 1-.3 1.2-.7l.3-.6c.3-.8.1-1.6-.6-2zm-.3 1.4l-.3.6c-.1.2-.3.2-.5.1l-.3-.2c-.1 0-.1-.1-.2-.2v-.3l.3-.6c.1-.1.2-.2.3-.2h.2l.3.1c.2.3.2.5.2.7z"}})])
          )
        }
      }
    